/**
 * 东方信息流接口
 */
import reqwest from 'reqwest';
export default {
  /**
   * 获取信息流数据
   * @param params
   * @param callback
   */
  getList (params, callback) {
    reqwest({
      url: '//minipc.eastday.com/ccms/026c799c08/026c799c08_269_737_v11_jsonp.json',
      data: params,
      type: 'jsonp',
			jsonpCallback: 'callback',
			jsonpCallbackName: 'callback',
      timeout: 20000
    // }).then(res => console.log(res))
	}).then(res => callback(null, res))
      .catch(err => callback(err));
  },
  /**
   * 获取娱乐八卦数据
   * @param params
   * @param callback
   */
  getEntList (params, callback) {
    reqwest({
      url: '//minipc.eastday.com/ccms/2d19ce8e7d/2d19ce8e7d_270_738_v11_jsonp.json',
      data: params,
      type: 'jsonp',
			jsonpCallback: 'jsonpcallback',
			jsonpCallbackName: 'callback',
      timeout: 20000
    }).then(res => callback(null, res))
      .catch(err => callback(err));
  }
}
